export default {
  zh: {
    organizationDetail: '组织详情',
    name: '公司名',
      tradingName: '经营名称',
    phone: '电话',
    fax: '传真',
    address: '地址',
    country: '国家',
    fiscalYearStarts: '财政年始于月',
    timeZone: '时区',
    usedDataSpace: '已用空间',
    fileStorage: '文件存储空间',
    lastModify: '上次修改',
    language: '语言',
    totalUser: '总用户数',
    activeUser: '活跃用户数',
    inactiveUser: '不活跃用户数',
    logo: '公司图标',
    logoTip: '公司图标会出现在页面左上角的导航栏里，推荐尺寸 160* 34, 只能上传png格式',
    addNewUser: '新增用户',
    clickToUpload: '点击上传',
      uploadCompanyLogo: '上传公司logo',
  },
  en: {
    organizationDetail: 'Organisation Details',
    name: 'Organisation Name',
      tradingName: 'Trading Name',
    phone: 'Phone',
    fax: 'Fax',
    address: 'Address',
    country: 'Country',
    fiscalYearStarts: 'Fiscal Year Starts Month',
    timeZone: 'Time Zone',
    usedDataSpace: 'Used Data Space',
    fileStorage: 'File Storage',
    lastModify: 'Last Modified By',
    language: 'Language',
    totalUser: 'Total Users',
    activeUser: 'Active Users',
    inactiveUser: 'Inactive Users',
    logo: 'Company Logo',
    logoTip: 'This logo will replace the logo on the top navigation bar. The recommend size is 160 * 34，the format must be png',
    addNewUser: 'Add New User',
    clickToUpload: 'Click to Upload',
      uploadCompanyLogo: 'Upload Company Logo',
  },
};



// WEBPACK FOOTER //
// ./src/views/Setup/CompanyInfo/i18n.js